let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("2VVfz")]).then(() => parcelRequire('1phEn'));